import { STORAGE_KEYS } from '../constants/config';

export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error(`Failed to save to localStorage: ${key}`, error);
  }
};

export const loadFromLocalStorage = (key, defaultValue = null) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : defaultValue;
  } catch (error) {
    console.error(`Failed to load from localStorage: ${key}`, error);
    return defaultValue;
  }
};

export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove from localStorage: ${key}`, error);
  }
};

export const saveTaskToLocalStorage = (taskId, taskData) => {
  const tasks = loadFromLocalStorage('tasks', {});
  tasks[taskId] = taskData;
  saveToLocalStorage('tasks', tasks);
};

export const updateLocalTaskStatus = (taskId, status, result) => {
  const tasks = loadFromLocalStorage('tasks', {});
  if (tasks[taskId]) {
    tasks[taskId].status = status;
    tasks[taskId].result = result;
    tasks[taskId].completedAt = new Date().toISOString();
    saveToLocalStorage('tasks', tasks);
  }
};

export const saveSuccessRecord = (record) => {
  const existingRecords = loadFromLocalStorage(STORAGE_KEYS.SUCCESS_RECORDS, []);
  const allRecords = [...existingRecords, record];
  saveToLocalStorage(STORAGE_KEYS.SUCCESS_RECORDS, allRecords.slice(-1000));
};

export const saveSuccessRecords = (records) => {
  const existingRecords = loadFromLocalStorage(STORAGE_KEYS.SUCCESS_RECORDS, []);
  const allRecords = [...existingRecords, ...records];
  saveToLocalStorage(STORAGE_KEYS.SUCCESS_RECORDS, allRecords.slice(-1000));
};